const KeyWithKeyRingReverse = () => (
  <svg
    width="145"
    height="140"
    viewBox="0 0 145 140"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.6703 61.2028C14.9664 83.8792 30.3555 105.267 53.0318 108.963C75.7081 112.667 97.0955 97.2783 100.792 74.6019C104.496 51.9255 89.1071 30.538 66.4308 26.8412C43.7545 23.1373 22.3671 38.5264 18.6703 61.2028ZM55.5246 42.5065C56.2611 38.0094 60.4961 34.9642 64.9931 35.6936C69.4902 36.4302 72.5354 40.6652 71.806 45.1622C71.0694 49.6592 66.8344 52.7045 62.3374 51.975C57.8404 51.2385 54.7952 47.0035 55.5246 42.5065Z"
      fill="white"
    />
    <path
      d="M102.412 57.0931C117.346 50.3463 123.987 32.7754 117.24 17.8413C110.493 2.90724 92.9223 -3.73374 77.9883 3.01304"
      stroke="#FB6E44"
      strokeWidth="0.75"
      strokeMiterlimit="10"
    />
    <path
      d="M124.419 132.079L140.167 139.615L144.806 122.874L121.058 70.2832L100.671 79.4959L124.419 132.079Z"
      fill="#0A0777"
    />
    <path
      d="M68.5159 63.6031L79.8772 88.7509C82.864 95.3594 90.6362 98.2973 97.2446 95.3105L135.202 78.1709C141.811 75.1841 144.749 67.4119 141.762 60.8035L130.401 35.6556C127.414 29.0472 119.642 26.1092 113.033 29.096L75.0755 46.2356C68.4671 49.2224 65.5291 56.9947 68.5159 63.6031ZM94.1601 60.4047C92.0523 55.7413 94.1276 50.2479 98.7909 48.1481C103.454 46.0403 108.948 48.1156 111.047 52.7789C113.147 57.4423 111.08 62.9357 106.417 65.0354C101.753 67.1433 96.2598 65.068 94.1601 60.4047Z"
      fill="#0A0777"
    />
    <path
      d="M145.001 103.752L132.093 133.058L114.481 94.0508L145.001 103.752Z"
      fill="#0A0777"
    />
    <path
      d="M139.58 91.73L126.672 121.037L109.053 82.0371L139.58 91.73Z"
      fill="#0A0777"
    />
    <path
      d="M97.102 89.8868L131.237 74.4743C136.366 72.1585 138.646 66.1235 136.33 60.9946L126.648 39.5509C124.332 34.422 118.297 32.1416 113.169 34.4573L79.0337 49.8699C73.9049 52.1856 71.6244 58.2207 73.9402 63.3495L83.6224 84.7933C85.9381 89.9222 91.9732 92.2026 97.102 89.8868Z"
      stroke="white"
      strokeWidth="0.75"
      strokeMiterlimit="10"
    />
    <path
      d="M131.165 129.492L136.853 132.446L138.408 126.229L120.829 87.3105L113.594 90.5741L131.165 129.492Z"
      stroke="white"
      strokeWidth="0.75"
      strokeMiterlimit="10"
    />
    <path
      d="M77.9887 3.01172C63.0547 9.7585 56.4137 27.3294 63.1605 42.2635C69.9073 57.1976 87.4781 63.8386 102.412 57.0918"
      stroke="#FB6E44"
      strokeWidth="0.75"
      strokeMiterlimit="10"
    />
    <path
      d="M18.4287 104.107V116.966"
      stroke="#0A0777"
      strokeWidth="0.75"
      strokeMiterlimit="10"
    />
    <path
      d="M24.8587 110.535H12"
      stroke="#0A0777"
      strokeWidth="0.75"
      strokeMiterlimit="10"
    />
    <path
      d="M3.68671 97.4809C5.72282 97.4809 7.37342 95.8303 7.37342 93.7941C7.37342 91.758 5.72282 90.1074 3.68671 90.1074C1.6506 90.1074 0 91.758 0 93.7941C0 95.8303 1.6506 97.4809 3.68671 97.4809Z"
      fill="#FB6E44"
    />
  </svg>
);

export default KeyWithKeyRingReverse;
